import { withSnackbar } from "notistack";
import React from "react";
import { connect } from "react-redux";

import EnhancferList from "../EnhancferList";
import * as actions from "../../../store/actions";
import * as appsyncOperations from "../../../utils/appsyncOperations";

const PropertiesTransferDialog = ({
  open,
  onClose,
  divisionId,
  serviceProviderId,
  propertiesById,
  divisionPropertyIds,
  everyOtherPropertyId,
  dispatch,
  enqueueSnackbar,
}) => {
  const [renderEnhancfer, setRenderEnhancfer] = React.useState(false);
  const [updatePending, setUpdatePending] = React.useState(false);

  React.useEffect(() => {
    if (open) {
      setRenderEnhancfer(true);
    }
  }, [open]);

  const saveChanges = async ({ right: nextDivisionPropertyIds }) => {
    setUpdatePending(true);
    const batchUpdateInput = [];
    // Start by determining which properties have received division updates.
    const difference = [
      divisionPropertyIds.filter(
        (propertyId) => !nextDivisionPropertyIds.includes(propertyId)
      ),
      nextDivisionPropertyIds.filter(
        (propertyId) => !divisionPropertyIds.includes(propertyId)
      ),
    ];
    // Queue property updates where properties had a division removed
    for (const propertyId of difference[0]) {
      const property = propertiesById[propertyId];
      if (property !== undefined) {
        batchUpdateInput.push({
          divisionId,
          relationalId: property.propertyId,
          operation: "DELETE",
          variant: "PROPERTY",
          serviceProviderId,
        });
      }
    }
    // Queue property updates where properties had a division added
    for (const propertyId of difference[1]) {
      const property = propertiesById[propertyId];
      if (property !== undefined) {
        batchUpdateInput.push({
          divisionId,
          relationalId: property.propertyId,
          operation: "CREATE",
          variant: "PROPERTY",
          serviceProviderId,
        });
      }
    }
    try {
      const updatedDivisionRelations = await appsyncOperations.batchWriteDivisionRelations(
        batchUpdateInput
      );
      dispatch(
        actions.divisions.setDivisions({
          divisionRelations: updatedDivisionRelations,
        })
      );
      onClose();
      setUpdatePending(false);
      enqueueSnackbar("Update successful!", { variant: "success" });
    } catch (error) {
      setUpdatePending(false);
      enqueueSnackbar(error, { variant: "error" });
    }
  };
  return (
    renderEnhancfer && (
      <EnhancferList
        title="Select properties"
        isOpen={open}
        onClose={onClose}
        onExited={() => setRenderEnhancfer(false)}
        data={propertiesById}
        leftLabel="Available properties"
        initLeft={everyOtherPropertyId}
        rightLabel="Selected properties"
        initRight={divisionPropertyIds}
        valueExtractor={(property) => property.displayName}
        searchId="propertyId"
        searchKeys={["displayName"]}
        onSaveHandler={saveChanges}
        loading={updatePending}
      />
    )
  );
};

const mapStateToProps = (state, ownProps) => {
  const division = state.divisions.byId[ownProps.divisionId];
  const divisionPropertyIds =
    division !== undefined
      ? Object.keys(division.properties.byId).filter(
          (propertyId) => !division.properties.byId[propertyId].isDeleted
        )
      : [];
  return {
    serviceProviderId: state.auth.user.attributes["custom:service_provider_id"],
    propertiesById: state.properties.byId,
    divisionPropertyIds,
    everyOtherPropertyId: Object.keys(state.properties.byId).filter(
      (propertyId) => {
        const property = state.properties.byId[propertyId];
        return (
          property !== undefined &&
          !property.isDeleted &&
          !divisionPropertyIds.includes(propertyId)
        );
      }
    ),
  };
};

export default withSnackbar(connect(mapStateToProps)(PropertiesTransferDialog));
